<template>
  <div class="customer-transactions pa-4">
    <v-card>
      <v-card-title>
        <v-icon left>mdi-history</v-icon>
        {{ $t('payment-method-ui.transactions') }}
      </v-card-title>

      <v-card-text>
        <payment-transaction-list
          v-if="customerId"
          :customer-id="customerId"
          :page-size="50"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PaymentTransactionList from '@/components/elements/PaymentTransactionList.vue'

export default {
  name: 'CustomerTransactions',

  components: {
    PaymentTransactionList
  },

  computed: {
    customerId() {
      return this.$route.params.id
    }
  }
}
</script>

<style scoped>
.customer-transactions {
  /* Add any custom styles here */
}
</style>
